<template>
  <div class="monitoring" v-loading="loading">
    <header>
      <h3>
        工单速览
        <span>(与日期筛选无关，展示对应状态的工单)</span>
      </h3>
      <el-button type="text" icon="el-icon-download" @click="btnClickExport">
        导出
      </el-button>
    </header>

    <div class="card-active">
      <div
        class="card-item"
        @click="btnClickSwitchActive(index)"
        v-for="(item, index) in cardActiveList"
        :key="item.desc"
        :style="{
          background: item.bgColor,
          color: item.color,
          cursor: 'pointer',
          border: '1px solid ' + item.color,
          backgroundColor: index == isActiveCard ? '#ffffff' : item.bgColor,
          boxShadow:
            index == isActiveCard ? '0 4px 12px rgba(0, 0, 0, 0.08)' : 'none',
          borderColor: index == isActiveCard ? item.color + '80' : item.color,
        }">
        <div
          class="header"
          :style="{
            paddingBottom: '6px',
            borderBottom:
              index == isActiveCard ? '2px solid ' + item.color : '0',
          }">
          <div class="number">{{ item.number }}</div>
          <div class="desc">{{ item.name }}</div>
        </div>
        <el-popover
          placement="top"
          width="200"
          trigger="hover"
          :content="item.desc">
          <i slot="reference" class="el-icon-question"></i>
        </el-popover>
      </div>
    </div>
    <div class="filter">
      <el-form label-width="80px" :model="monitoringForm" :inline="true">
        <el-form-item label="剩余天数" v-if="isActiveCard === 0">
          <el-select
            v-model="monitoringForm.days_remaining_operator"
            placeholder=""
            style="width: 60px">
            <el-option
              v-for="item in remainingOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-input-number
            size="mini"
            placeholder="输入天数"
            style="width: 140px; margin-left: 10px"
            :max="99"
            :min="0"
            :value="
              monitoringForm.days_remaining === ''
                ? undefined
                : monitoringForm.days_remaining
            "
            @change="
              (val) => (monitoringForm.days_remaining = val)
            "></el-input-number>
        </el-form-item>
        <el-form-item label="已超期天数" v-if="isActiveCard === 0">
          <el-select
            v-model="monitoringForm.days_expired_operator"
            placeholder=""
            style="width: 60px">
            <el-option
              v-for="item in remainingOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-input-number
            size="mini"
            placeholder="输入天数"
            style="width: 140px; margin-left: 10px"
            :max="99"
            :min="0"
            :value="
              monitoringForm.days_expired === ''
                ? undefined
                : monitoringForm.days_expired
            "
            @change="
              (val) => (monitoringForm.days_expired = val)
            "></el-input-number>
        </el-form-item>

        <el-form-item label="剩余天数" v-if="isActiveCard === 1">
          <el-select
            v-model="monitoringForm.days_remaining_operator1"
            placeholder=""
            style="width: 60px">
            <el-option
              v-for="item in remainingOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-input-number
            size="mini"
            placeholder="输入天数"
            style="width: 140px; margin-left: 10px"
            :max="99"
            :min="0"
            :value="
              monitoringForm.days_remaining1 === ''
                ? undefined
                : monitoringForm.days_remaining1
            "
            @change="
              (val) => (monitoringForm.days_remaining1 = val)
            "></el-input-number>
        </el-form-item>
        <el-form-item label="已超期天数" v-if="isActiveCard === 1">
          <el-select
            v-model="monitoringForm.days_expired_operator1"
            placeholder=""
            style="width: 60px">
            <el-option
              v-for="item in remainingOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-input-number
            size="mini"
            placeholder="输入天数"
            style="width: 140px; margin-left: 10px"
            :max="99"
            :min="0"
            :value="
              monitoringForm.days_expired1 === ''
                ? undefined
                : monitoringForm.days_expired1
            "
            @change="
              (val) => (monitoringForm.days_expired1 = val)
            "></el-input-number>
        </el-form-item>

        <el-form-item label="滞留天数" v-if="isActiveCard === 2">
          <el-select
            v-model="monitoringForm.overdue_days_operator"
            placeholder=""
            style="width: 60px">
            <el-option
              v-for="item in remainingOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-input-number
            size="mini"
            placeholder="输入天数"
            style="width: 140px; margin-left: 10px"
            :max="99"
            :min="0"
            :value="
              monitoringForm.overdue_days === ''
                ? undefined
                : monitoringForm.overdue_days
            "
            @change="
              (val) => (monitoringForm.overdue_days = val)
            "></el-input-number>
        </el-form-item>
        <el-button type="primary" @click="handleFilter">筛选 </el-button>
        <el-button type="primary" @click="handleReset"> 重置 </el-button>
      </el-form>
    </div>
    <div
      class="content"
      v-loading="dataLoading"
      v-if="cardActiveListItem.length > 0">
      <div
        v-for="(item, index) in cardActiveListItem"
        :key="index"
        class="content-item"
        :style="{
          borderLeft: '2px solid ' + item.tagColor,
          borderRadius: '8px',
        }">
        <div class="left">
          <p>
            <span>{{ item.label_names }}</span>
            <span v-show="item.label_names" style="margin: 0 2px">|</span>

            <span>{{ item.urgent_level }}</span>
            <span v-show="item.urgent_level" style="margin: 0 2px">|</span>

            <span>{{ item.project_name }}</span>
          </p>
          <p v-if="isActiveCard === 0 || isActiveCard === 2">
            <span>工单ID: &nbsp;</span>
            <span>{{ item.order_id }}</span>
            <span v-show="item.order_id" style="margin: 0 2px">|</span>
            <span>{{ item.creator }}</span>
            <span v-show="item.creator" style="margin: 0 2px">|</span>
            <span>{{ item.plat }}</span>
            <span v-show="item.plat" style="margin: 0 2px">|</span>
            <span>{{ item.is_new }}</span>
            <span v-show="item.is_new" style="margin: 0 2px">|</span>
            <span>{{ item.app_type }}</span>
            <span v-show="item.app_type" style="margin: 0 2px">|</span>
            <span>{{ item.package_type }}</span>
            <span v-show="item.package_type" style="margin: 0 2px">|</span>
            <span>{{ item.game_classify }}</span>
          </p>
          <p v-if="isActiveCard === 0" :style="{ color: item.tagColor }">
            <span> 期望交付 : </span>
            <span>
              {{ item.expected_end_time }}
            </span>
            <span v-show="item.expected_end_time" style="margin: 0 2px">|</span>
            <span>
              {{ item.date_diff }}
            </span>
          </p>

          <p v-if="isActiveCard === 1">
            <span>工单ID: &nbsp;</span>
            <span>{{ item.order_id }}</span>
            <span v-show="item.order_id" style="margin: 0 2px">|</span>
            <span>任务ID: &nbsp;</span>
            <span>{{ item.detail_id }}</span>
            <span v-show="item.detail_id" style="margin: 0 2px">|</span>
            <span>{{ item.material_group }}</span>
            <span v-show="item.material_group" style="margin: 0 2px">|</span>
            <span>{{ item.material_producer }}</span>
            <span v-show="item.material_producer" style="margin: 0 2px">|</span>
          </p>
          <p v-if="isActiveCard === 1" :style="{ color: item.tagColor }">
            <span> 交付日期 : </span>
            <span>
              {{ item.finish_time }}
            </span>
            <span v-show="item.finish_time" style="margin: 0 2px">|</span>
            <span>
              {{ item.date_diff }}
            </span>
            <span v-show="item.date_diff" style="margin: 0 2px">|</span>
            <span> 素材完成度 : </span>
            <span>
              {{ item.material_completion_rate }}
            </span>
          </p>

          <p v-if="isActiveCard === 2" :style="{ color: item.tagColor }">
            <span> 创建日期 : </span>
            <span>
              {{ item.order_create_time }}
            </span>
            <span v-show="item.order_create_time" style="margin: 0 2px">|</span>
            <span>
              {{ item.date_diff }}
            </span>
          </p>
        </div>
        <div class="right">
          <div
            :style="{
              background: item.tagColor,
              color: '#ffffff',
              padding: '4px 6px',
              borderRadius: '20px',
            }">
            {{ item.work_order_status }}
          </div>
        </div>
      </div>
    </div>
    <div class="content-empty" v-else>暂无数据....</div>
  </div>
</template>
<script>
import API from "@/api/workOrder/board.js"
import { debounce } from "lodash"
import dayjs from "dayjs"
export default {
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      dataLoading: false,
      monitoringForm: {
        days_remaining_operator: ">=",
        days_remaining: "",
        days_expired_operator: ">=",
        days_expired: "",

        days_remaining1: "",
        days_remaining_operator1: ">=",
        days_expired1: "",
        days_expired_operator1: ">=",

        overdue_days_operator: ">=",
        overdue_days: "",
      },
      remainingOptions: [
        {
          label: ">=",
          value: ">=",
        },
        {
          label: "=",
          value: "=",
        },
        {
          label: "<=",
          value: "<=",
        },
      ],
      isActiveCard: 0,
      cardActiveList: [
        {
          name: "工单待指派",
          number: 5,
          color: "#1b61ff",
          bgColor: "#e2e9f9",
          desc: "工单待指派列表展示所有权限内待指派的工单",
        },
        {
          name: "素材未完成",
          number: 12,
          color: "#ff7e04",
          bgColor: "#fff8f2",
          desc: "素材未完成列表展示任务维度的所有包含待上传素材的任务",
        },
        {
          name: "工单滞留",
          number: 5,
          color: "#f65757",
          bgColor: "#fef5f5",
          desc: "工单滞留列表展示工单创建了7天以上还未指派的工单",
        },
      ],
      // work_order_unassigned 待指派
      // material_unfinished 素材未完成
      // work_order_backlog  工单滞留
      cardActiveListItem: [
        // {
        //   work_order_status: "超期未指派",
        //   tagColor: "#a159ee",
        //   urgent_level: "加急",
        //   label_names: "插单",
        //   project_name: "项目名称XXX",
        //   order_id: 164045,
        //   creator: "刘俊楠",
        //   plat: "O",
        //   is_new: "新",
        //   app_type: "游戏",
        //   package_type: "安卓应用",
        //   game_classify: "IAA",
        //   expected_end_time: "2025年9月4日",
        //   date_diff: "已超期两天",
        // },
        // {
        //   work_order_status: "超期未指派",
        //   tagColor: "#ff7e04",
        //   urgent_level: "加急",
        //   label_names: "插单",
        //   project_name: "项目名称XXX",
        //   order_id: 164045,
        //   creator: "刘俊楠",
        //   plat: "O",
        //   is_new: "新",
        //   app_type: "游戏",
        //   package_type: "安卓应用",
        //   game_classify: "IAA",
        //   expected_end_time: "2025年9月4日",
        //   date_diff: "已超期两天",
        // },
      ],
      totalData: {},
    }
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        this.handleFilter()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    btnClickSwitchActive(index) {
      this.isActiveCard = index
      // 使用Promise的then/catch来判断操作完成状态
      this.dataReconstruction()
        .then((result) => {
          console.log("数据重构成功:", result)
          // 可以在这里添加完成后的操作
        })
        .catch((error) => {
          console.error("数据重构失败:", error)
          // 可以在这里添加错误处理逻辑
          this.$message.error("数据加载失败，请重试")
        })
    },
    handleReset() {
      this.monitoringForm = {
        days_remaining_operator: ">=",
        days_remaining: "",
        days_expired_operator: ">=",
        days_expired: "",
        days_remaining1: "",
        days_remaining_operator1: ">=",
        days_expired1: "",
        days_expired_operator1: ">=",
        overdue_days_operator: ">=",
        overdue_days: "",
      }
      this.handleFilter()
    },
    btnClickExport() {
      let params = {
        ...this.form,
        range_time:
          this.form.range_time?.length > 0
            ? this.form?.range_time.join("/")
            : "",
        ...this.monitoringForm,
        export: 1,
      }

      API.getWorkOrderQuickOverview(params)
        .then((res) => {
          this.$message.success(res.info)
        })
        .catch((err) => {
          this.$message.error(err.info)
        })
    },
    handleFilter: debounce(function () {
      this.loading = true
      // this.monitoringForm.overdue_days_operator = ""
      // this.monitoringForm.overdue_days = ""

      // this.monitoringForm.days_remaining_operator = ""
      // this.monitoringForm.days_remaining = ""
      // this.monitoringForm.days_expired_operator = ""
      // this.monitoringForm.days_expired = ""

      // work_order_unassigned 待指派
      // material_unfinished 素材未完成
      // work_order_backlog  工单滞留
      let params = {
        ...this.form,
        range_time:
          this.form.range_time?.length > 0
            ? this.form?.range_time.join("/")
            : "",
        ...this.monitoringForm,
      }
      API.getWorkOrderQuickOverview(params)
        .then((res) => {
          if (res.code === 200) {
            this.totalData = res.data
            this.cardActiveList[0].number = res.data.work_order_unassigned_num
            this.cardActiveList[1].number = res.data.no_upload_material_num
            this.cardActiveList[2].number = res.data.work_order_backlog_num
            this.loading = false
            // 使用Promise的then/catch来判断数据重构的完成状态
            this.dataReconstruction()
              .then((result) => {
                console.log("数据加载和重构成功完成:", result)
                // 这里可以移除手动设置的loading=false，因为Promise内部已经处理
              })
              .catch((error) => {
                console.error("数据重构失败:", error)
                this.dataLoading = false
                this.$message.error("数据加载失败，请重试")
              })
          } else {
            this.dataLoading = false
            this.$message.error("数据请求失败")
          }
        })
        .catch((error) => {
          console.error("API请求失败:", error)
          this.dataLoading = false
          this.$message.error("网络请求失败，请检查网络连接")
        })
    },500),
    // 处理数据重构，返回Promise以便判断执行完成状态
    dataReconstruction() {
      // 使用Promise封装，便于判断异步操作完成状态
      return new Promise((resolve, reject) => {
        try {
          this.dataLoading = true
          if (this.isActiveCard === 0) {
            this.cardActiveListItem = this.totalData.work_order_unassigned.map(
              (item) => {
                return {
                  ...item,
                  expected_end_time: dayjs(item.expected_end_time).format(
                    "YYYY-MM-DD"
                  ),
                  // 颜色
                  tagColor:
                    item.work_order_status === "超期未指派"
                      ? "#dc554b"
                      : "#e87d35",
                }
              }
            )
          } else if (this.isActiveCard === 1) {
            this.cardActiveListItem = this.totalData.material_unfinished.map(
              (item) => {
                return {
                  ...item,
                  // 颜色
                  tagColor:
                    item.work_order_status === "超期未完成"
                      ? "#dc554b"
                      : "#e87d35",
                }
              }
            )
          } else if (this.isActiveCard === 2) {
            this.cardActiveListItem = this.totalData.work_order_backlog.map(
              (item) => {
                return {
                  ...item,
                  // 颜色
                  tagColor: "#a159ee",
                }
              }
            )
          }

          this.dataLoading = false
          // 标记操作成功完成
          resolve({ success: true, message: "数据重构完成" })
        } catch (error) {
          console.error("数据重构失败:", error)
          this.dataLoading = false
          reject({ success: false, message: "数据重构失败", error })
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.monitoring {
  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    h3 {
      span {
        font-size: 12px;
        color: #a9afb9;
        font-weight: normal;
      }
    }
  }
  .filter {
    display: flex;
    align-items: baseline;
    background: #f9fafb;
    border: 1px solid #e9ebee;
    border-radius: 10px;
    padding: 10px;
    .el-form {
      ::v-deep(.el-form-item) {
        margin-bottom: 0 !important;
      }
    }
  }
  .card-active {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .card-item {
      width: 32%;
      text-align: center;
      padding: 10px 6px;
      border-radius: 10px;
      transition: all 0.3s ease;
      position: relative;
      .header {
        .number {
          font-weight: bold;
          font-size: 18px;
        }
      }
      span {
        position: absolute;
        right: 5px;
        top: 5px;
        color: #a3abc6;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
  .content {
    height: 400px;
    overflow-y: auto;
    .content-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      border-bottom: 1px solid #f7f7f7;
      margin: 10px 0;
      .left {
        width: 80%;
        p:nth-child(2) {
          color: #6e8eae;
        }
      }
      .right {
        width: 20%;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        div {
          width: 90px;
          text-align: center;
        }
      }
    }
  }
  .content-empty {
    margin-top: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
  }
}
</style>
